'use client';

import React, { useEffect } from 'react';

import Image from 'next/image';

import { usePictureViewerContext } from 'providers/picture-viewer-provider';

import { styles } from '.';

type TProps = {
  pictures: {
    asset?: {
      url?: string;
    };
  }[];
};

const PictureViewer = (props: TProps) => {
  const { pictures } = props;

  const { setPictures, setSelector, setIsShown } = usePictureViewerContext();

  useEffect(() => {
    setPictures(pictures);
  }, [pictures, setPictures]);

  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        {pictures?.map((picture, index: number) => (
          <li key={`picture-${index}`} className={styles.images.item}>
            <Image
              src={picture?.asset?.url ?? ''}
              alt={`picture-${index}`}
              className={styles.images.image}
              fill
              onClick={() => {
                setSelector(index);
                setIsShown(true);
              }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PictureViewer;
